module.exports = __webpack_public_path__ + "static/media/rankingi_z_wynikami_graczy_z_calej_polski.59bd821f.svg";